import { defineComponent as _defineComponent } from 'vue'
import {
  PropType, computed,
} from 'vue';
import { SubscriptionInfo } from '@/services/billing-utils';
import i18n from '@/plugins/i18n';
import PaymentResultSuccessLayout from './PaymentResultSuccessLayout.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'PaymentSuccessSubscription',
  props: {
  subscriptionInfo: { type: Object as PropType<SubscriptionInfo>, required: true },
},
  setup(__props) {

const props = __props;




const subscriptionState = computed(() => {
  if (props.subscriptionInfo.active) return { active: true };
  if (props.subscriptionInfo.awaitingPayment) return { awaitingPayment: true };
  return { error: true };
});

const title = computed(() => {
  if (subscriptionState.value.active) { return i18n.t('label.thank_you'); }
  if (subscriptionState.value.awaitingPayment) { return i18n.t('label.payment_processing'); }
  return i18n.t('label.oops');
});

const subtitle = computed(() => {
  if (subscriptionState.value.active) { return i18n.t('label.your_subscription_is_active'); }
  if (subscriptionState.value.awaitingPayment) { return i18n.t('message.payment_processing'); }
  return i18n.t('error.billing_general');
});

const icon = computed(() => {
  if (subscriptionState.value.active) { return 'mdi-checkbox-marked-circle'; }
  if (subscriptionState.value.awaitingPayment) { return 'mdi-alert'; }
  return 'mdi-alert';
});

const footeri18nPath = computed(() => {
  if (!subscriptionState.value.active) return 'message.billing_method_setup';
  return props.subscriptionInfo.sentInvoice
    ? 'message.billing_subscription_invoice_sent_on' : 'message.billing_subscription_renewed_on';
});


return { __sfc: true,props, subscriptionState, title, subtitle, icon, footeri18nPath, PaymentResultSuccessLayout }
}

})